import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useAppContext from "../../../utils/Reducers";
import ButtonBar from "../../../components/Layout/ButtonBar";
import SearchBar from "./SearchBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import SelectBox from "../../../components/SelectBox";
import { isFieldDisabled } from "../../../utils/validators";
import useAuiGridMethods from "../../../hooks/AuiGrid/useAuiGridMethods";
import { useId } from "react-id-generator";
import InspectionReg from "./InspectionReg";
import Viewer from "./Viewer";
import cameraIcon from "../../../images/video.png";
import { ModalConfirm } from "../../../components/Confirm";
import { ModalErrorConfirm } from "../../../components/ErrorConfirm";
import { ModalWeightInListPop } from "../../Popup/WeightInListPop";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import OutgoingWaitList from "./OutgoingWaitList";
import IncomeHistory from "./IncomeHistory";
import { PageImportLazy } from "../../../DSRouter";
import Loading from "../../../components/Loading";
import { useInterval } from "../../../utils/validators";

const InspectionProgressReg = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    onCameraClose() {
      viewerRef0.current.onCameraDestory();
      viewerRef1.current.onCameraDestory();
      viewerRef2.current.onCameraDestory();
      viewerRef3.current.onCameraDestory();
    },
  }));

  const viewerRef0 = useRef();
  const viewerRef1 = useRef();
  const viewerRef2 = useRef();
  const viewerRef3 = useRef();

  const [key, setKey] = useState("inspection");
  const [scrapAreaCd, setScrapAreaCd] = useState("");
  const [cameraInfo, setCameraInfo] = useState(null);

  const {
    store: { userInfo },
  } = useAppContext();

  const [primaryParameters, setPrimaryParameters] = useState({
    schSystemCd: userInfo.defaultCompNo,
    schPlantCd: userInfo.defaultPlantNo,
    schScrapAreaCd: "",
  });

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    codeSearch(userInfo.defaultPlantNo);
  }, []);

  useInterval(async () => {
    await searchRecordingScrapAreaList();
  }, 10000);

  //const [viewerList, setViewerList] = useState([]);
  const [selectTab, setSelectTab] = useState(0);

  const [state, setState] = useState("normaled");

  //추가, 수정일때 항목의 disabled 결정
  const disabledFields = {
    created: [""],
    updated: ["systemCd"],
  };

  const initItem = {
    status: "C",
    systemCd: "",
    inspNo: "",
    inspDt: "",
    plantCd1: "",
    plantCd: "",
    transCd: "",
    vhclNo: "",
    vhclType: "",
    itemCd: "",
    vndrCd: "",
    vndrNm: "",
    rvndrCd: "",
    rvndrNm: "",
    loadAreaCd: "",
    loadAreaNm: "",
    scrapAreaCd: "",
    scrapAreaNm: "",
    magnet: "",
    dcsnItemCd: "",
    subItemCd1: "",
    subItemPrdCd1: "",
    subItemRate1: "",
    subItemCd2: "",
    subItemPrdCd2: "",
    subItemRate2: "",
    subItemCd3: "",
    subItemPrdCd3: "",
    subItemRate3: "",
    outageCd: "",
    outageWght: "",
    outageRsn: "",
    returnCd: "",
    returnWght: "",
    returnRsn: "",
    dprctCd: "",
    dprctRate: "",
    scalNo: "",
    tmsOdrNo: "",
    workerId: "",
    inspCd: "R",
    rmks: "",
    inptDt: "",
    wghtDt: "",
    totalWeight: "",
    dcsnDesc: "",
    dcsnItemScoreCd: ""
  };

  const [fieldValues, setFieldValues] = useState(initItem);
  const [milestoneInfo, setMilestoneInfo] = useState(null);

  const [recordingValue, setRecordingValue] = useState([]);
  const [value, setValue] = useState("-1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //공통코드 검색 URL
  const SEARCH_CODE_URL = "/common/code/searchDetailCode.do";

  //카메라정보 검색 URL
  const SEARCH_CAMERA_URL = "/inspection/video/searchCameraList.do";

  //단일 카메라정보 검색 URL
  const SEARCH_CAMERAINFO_URL = "/inspection/video/searchCameraInfo.do";

  //녹화 카메라정보 검색 URL
  const SEARCH_RECORDCAMERA_URL = "/inspection/video/searchRecordCameraList.do";

  //녹화중인 입고된 차량정보 검색
  const SEARCH_WEIGHTIN_URL = "/inspection/video/searchWeightInList.do";

  //녹화되고 있는 하차지와 차량번호 검색
  const SEARCH_RECORDING_SCRAPAREA_URL =
    "/inspection/video/searchRecordingScrapAreaList.do";

  //마일스톤 정보 검색 URL
  const SEARCH_MILESTONE_URL = "/inspection/video/searchMilestoneInfo.do";

  const SAVE_INSPECTION_PROGRESS_URL =
    "/inspection/video/saveInspectionProgress.do";

  //카메라 수동녹화 시작
  //const CAMERA_RECORD_URL = "http://localhost:7090/milestone/cameraRecord";
  //const CAMERA_RECORD_URL = "http://192.168.20.216:8080/milestone/cameraRecord";
  //const CAMERA_RECORD_URL = "http://imsns.idaehan.com:8080/milestone/cameraRecord";
  const CAMERA_RECORD_URL_NS =
    "https://imsns.idaehan.com:8443/milestone/cameraRecord";
  const CAMERA_RECORD_URL_NRC =
    "https://imsrelaynrc.idaehan.com:8443/milestone/cameraRecord";
  const CAMERA_RECORD_URL_GP =
    "https://imsrelaygp.idaehan.com:8443/milestone/cameraRecord";

  //카메라스냅샷 저장
  //const CAMERA_SNAPSHOT_URL = "http://localhost:7090/milestone/camearSnapshot";
  //const CAMERA_SNAPSHOT_URL = "http://192.168.20.216:8080/milestone/camearSnapshot";
  //const CAMERA_SNAPSHOT_URL = "http://imsns.idaehan.com:8080/milestone/camearSnapshot";
  const CAMERA_SNAPSHOT_URL_NS =
    "https://imsns.idaehan.com:8443/milestone/camearSnapshot";
  const CAMERA_SNAPSHOT_URL_GP =
    "https://imsrelaygp.idaehan.com:8443/milestone/camearSnapshot";
  const CAMERA_SNAPSHOT_URL_NRC =
    "https://imsrelaynrc.idaehan.com:8443/milestone/camearSnapshot";

  //const CAMERA_RECONNECT_URL = "http://localhost:7090/stream/reconnect";
  const CAMERA_RECONNECT_URL =
    "https://imsrelay.idaehan.com:8443/stream/reconnect";
  const CAMERA_RECONNECT_URL_YK =
    "https://imsrelaygp.idaehan.com:8443/stream/reconnect";
  const CAMERA_RECONNECT_URL_DH =
    "https://imsrelayns.idaehan.com:8443/stream/reconnect";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_CODE_URL,
    },
    { manual: true }
  );

  const [codeData, setCodeData] = useState([]);

  //카메라 RTSP 서버 주소들
  const [rtspValues, setRtspValues] = useState({
    rtsp1: "",
    rtsp2: "",
    rtsp3: "",
    rtsp4: "",
  });

  //사업장구분 검색을 할때 호출되는 기능
  const codeSearch = async (schPlantCd) => {
    //console.log(schPlantCd);
    if (schPlantCd === "") {
      schPlantCd = primaryParameters.schPlantCd;
    }
    //console.log(schPlantCd);

    await searchRecordingScrapAreaList();

    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_CODE_URL,
      params: {
        mastCd: "SCRAP_AREA_CD",
        detlCd: "",
        useYn: "Y",
        attr2: "Y",
        attr3: schPlantCd,
      },
    });
    setCodeData(data);
  };

  //현재 녹화되고 있는 하차지역과 차량번호 검색
  const searchRecordingScrapAreaList = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_RECORDING_SCRAPAREA_URL,
    });
    setRecordingValue(data);
    //데이터가 있으면 현재 선택한 하차지역에 배차정보와 다르면 새로운 배차정보를 가져와 입력함
    if (data.length > 0) {
      for (var i = 0; i < data.length; i++) {
        if (
          data[i].scrapAreaCd === primaryParameters.schScrapAreaCd &&
          (data[i].vhclNo !== fieldValues.vhclNo || fieldValues.vhclNo === "")
        ) {
          const response = await fetchData({
            url: SEARCH_WEIGHTIN_URL,
            params: {
              tmsOdrNo: data[i].tmsOdrNo,
            },
            data,
          });

          var result = response.data.data;
          if (result.length > 0) {
            var weightInfo = result[0];
            //console.log(weightInfo);
            let item = {
              status: "C",
              systemCd: weightInfo.systemCd,
              inspNo: weightInfo.wssId,
              inspDt: "",
              plantCd1: weightInfo.plantCd1,
              plantCd: weightInfo.plantCd,
              transCd: weightInfo.transCd,
              vhclNo: weightInfo.vhclNo,
              vhclType: weightInfo.vhclType,
              totalWeight: weightInfo.totalWeight,
              itemCd: weightInfo.itemCd,
              vndrCd: weightInfo.vndrCd,
              vndrNm: weightInfo.vndrNm,
              rvndrCd: weightInfo.rvndrCd,
              rvndrNm: weightInfo.rvndrNm,
              loadAreaCd: weightInfo.loadAreaCd,
              loadAreaNm: weightInfo.loadAreaNm,
              scrapAreaCd: weightInfo.scrapAreaCd,
              scrapAreaNm: "",
              magnet: "",
              dcsnItemCd: "",
              subItemCd1: "",
              subItemPrdCd1: "",
              subItemRate1: "",
              subItemCd2: "",
              subItemPrdCd2: "",
              subItemRate2: "",
              subItemCd3: "",
              subItemPrdCd3: "",
              subItemRate3: "",
              outageCd: "",
              outageWght: "",
              outageRsn: "",
              returnCd: "",
              returnWght: "",
              returnRsn: "",
              dprctCd: "",
              dprctRate: "",
              scalNo: "",
              tmsOdrNo: weightInfo.tmsOdrNo,
              workerId: "",
              inspCd: "R",
              rmks: "",
              wghtDt: weightInfo.inptDt,
              returnCnt: weightInfo.returnCnt,
            };
            setFieldValues(item);
            setState("created");
          }
        }
      }
    }
  };

  //입차계근 버튼 이벤트 함수
  const handleIncomingClick = async () => {
    if (primaryParameters.schPlantCd === "") {
      ModalConfirm({
        title: "사업장선택 ",
        description: "사업장구분을 선택하지 않았습니다. ",
        type: "alert",
      });
      return;
    }
    ModalWeightInListPop({
      onSearchInfo: popWeightInfo,
      plantCd: primaryParameters.schPlantCd,
    });
  };

  const popWeightInfo = useCallback(async (weightInfo) => {
    //console.log(weightInfo);
    if (weightInfo) {
      let item = {
        status: "C",
        systemCd: weightInfo.systemCd,
        inspNo: weightInfo.wssId,
        inspDt: "",
        plantCd1: weightInfo.plantCd1,
        plantCd: weightInfo.plantCd,
        transCd: weightInfo.transCd,
        drivTel: weightInfo.drivTel,
        drivNm: weightInfo.drivNm,
        vhclNo: weightInfo.vhclNo,
        vhclType: weightInfo.vhclType,
        totalWeight: weightInfo.totalWeight,
        itemCd: weightInfo.itemCd,
        vndrCd: weightInfo.vndrCd,
        vndrNm: weightInfo.vndrNm,
        rvndrCd: weightInfo.rvndrCd,
        rvndrNm: weightInfo.rvndrNm,
        loadAreaCd: weightInfo.loadAreaCd,
        loadAreaNm: weightInfo.loadAreaNm,
        scrapAreaCd: weightInfo.scrapAreaCd,
        scrapAreaNm: "",
        magnet: "",
        dcsnItemCd: "",
        subItemCd1: "",
        subItemPrdCd1: "",
        subItemRate1: "",
        subItemCd2: "",
        subItemPrdCd2: "",
        subItemRate2: "",
        subItemCd3: "",
        subItemPrdCd3: "",
        subItemRate3: "",
        outageCd: "",
        outageWght: "",
        outageRsn: "",
        returnCd: "",
        returnWght: "",
        returnRsn: "",
        dprctCd: "",
        dprctRate: "",
        scalNo: "",
        tmsOdrNo: weightInfo.tmsOdrNo,
        workerId: "",
        inspCd: "R",
        rmks: "",
        wghtDt: weightInfo.inptDt,
        returnCnt: weightInfo.returnCnt,
      };
      setFieldValues(item);

      setState("created");
      await codeSearch(weightInfo.plantCd1);
      if (weightInfo.scrapAreaCd !== primaryParameters.schScrapAreaCd) {
        await onCamera(weightInfo.scrapAreaCd, weightInfo.systemCd);
      }
      await searchRecordingScrapAreaList();
      setPrimaryParameters({
        ...primaryParameters,
        ["systemCd"]: weightInfo.systemCd,
        ["schPlantCd"]: weightInfo.plantCd1,
        ["schScrapAreaCd"]: weightInfo.scrapAreaCd,
      });
      onSetRecord(weightInfo.wssId, weightInfo.tmsOdrNo);
    }
  });
  const handleMasterSave = async () => {
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      let totalRate =
        (fieldValues.subItemRate1 === "" || fieldValues.subItemRate1 === null
          ? 0
          : parseInt(fieldValues.subItemRate1)) +
        (fieldValues.subItemRate2 === "" || fieldValues.subItemRate2 === null
          ? 0
          : parseInt(fieldValues.subItemRate2)) +
        (fieldValues.subItemRate3 === "" || fieldValues.subItemRate3 === null
          ? 0
          : parseInt(fieldValues.subItemRate3));

      if (fieldValues.scrapAreaCd === "" || fieldValues.scrapAreaCd === null) {
        ModalErrorConfirm({
          title: "필수항목체크 ",
          description: "하차지를 선택하지 않았습니다. ",
          type: "alert",
        });
        return;
      }

      if (totalRate !== 100) {
        ModalErrorConfirm({
          title: "비율합계 오류",
          description: "세부품목비율 합계가 100%가 아닙니다. 다시 입력하세요..",
        });
        return;
      }

      if (fieldValues.dcsnItemCd === "" || fieldValues.dcsnItemCd === null) {
        ModalErrorConfirm({
          title: "필수항목체크 ",
          description: "검수등급을 선택하지 않았습니다. ",
          type: "alert",
        });
        return;
      }

      let total11 =
        fieldValues.subItemCd1 === "" || fieldValues.subItemCd1 === null
          ? 0
          : parseInt(fieldValues.subItemCd1);
      let total12 =
        fieldValues.subItemPrdCd1 === "" || fieldValues.subItemPrdCd1 === null
          ? 0
          : parseInt(fieldValues.subItemPrdCd1);
      let total13 =
        fieldValues.subItemRate1 === "" || fieldValues.subItemRate1 === null
          ? 0
          : parseInt(fieldValues.subItemRate1);
      //console.log();

      if (total11 === 0 || total12 === 0 || total13 === 0) {
        ModalErrorConfirm({
          title: "필수항목체크",
          description: "세부등급1, 세부품목1, 세부비율1은 필수항목입니다. ",
        });
        return;
      }

      if (
        (total11 === 0 && total12 === 0 && total13 === 0) ||
        (total11 > 0 && total12 > 0 && total13 > 0)
      ) {
      } else {
        ModalErrorConfirm({
          title: "비율합계 선택",
          description:
            "세부등급1, 세부품목1, 세부비율1 중 선택하지 않은 항목이 있습니다. ",
        });
        return;
      }

      let total21 =
        fieldValues.subItemCd2 === "" || fieldValues.subItemCd2 === null
          ? 0
          : parseInt(fieldValues.subItemCd2);
      let total22 =
        fieldValues.subItemPrdCd2 === "" || fieldValues.subItemPrdCd2 === null
          ? 0
          : parseInt(fieldValues.subItemPrdCd2);
      let total23 =
        fieldValues.subItemRate2 === "" || fieldValues.subItemRate2 === null
          ? 0
          : parseInt(fieldValues.subItemRate2);

      if (
        (total21 === 0 && total22 === 0 && total23 === 0) ||
        (total21 > 0 && total22 > 0 && total23 > 0)
      ) {
      } else {
        ModalErrorConfirm({
          title: "비율합계 선택",
          description:
            "세부등급2, 세부품목2, 세부비율2 중 선택하지 않은 항목이 있습니다. ",
        });
        return;
      }

      let total31 =
        fieldValues.subItemCd3 === "" || fieldValues.subItemCd3 === null
          ? 0
          : parseInt(fieldValues.subItemCd3);
      let total32 =
        fieldValues.subItemPrdCd3 === "" || fieldValues.subItemPrdCd3 === null
          ? 0
          : parseInt(fieldValues.subItemPrdCd3);
      let total33 =
        fieldValues.subItemRate3 === "" || fieldValues.subItemRate3 === null
          ? 0
          : parseInt(fieldValues.subItemRate3);

      if (
        (total31 === 0 && total32 === 0 && total33 === 0) ||
        (total31 > 0 && total32 > 0 && total33 > 0)
      ) {
      } else {
        ModalErrorConfirm({
          title: "비율합계 선택",
          description:
            "세부등급3, 세부품목3, 세부비율3 중 선택하지 않은 항목이 있습니다. ",
        });
        return;
      }

      if (
        fieldValues.outageWght === "" ||
        fieldValues.outageWght === null ||
        fieldValues.outageWght === undefined
      ) {
      } else {
        if (
          fieldValues.outageRsn === "" ||
          fieldValues.outageRsn === null ||
          fieldValues.outageRsn === undefined
        ) {
          alert("감량사유를 선택하지 않았습니다. ");
          return;
        }
      }

      if (
        fieldValues.returnCd === "" ||
        fieldValues.returnCd === null ||
        fieldValues.returnCd === undefined
      ) {
      } else {
        if (
          fieldValues.returnRsn === "" ||
          fieldValues.returnRsn === null ||
          fieldValues.returnRsn === undefined
        ) {
          alert("반품사유를 선택하지 않았습니다. ");
          return;
        }
      }
      if (fieldValues.systemCd === "DH") {
        if (
          fieldValues.dprctRate === "" ||
          fieldValues.dprctRate === null ||
          fieldValues.dprctRate === undefined
        ) {
        } else {
          if (
            fieldValues.dprctCd === "" ||
            fieldValues.dprctCd === null ||
            fieldValues.dprctCd === undefined
          ) {
            alert("감가내역를 선택하지 않았습니다. ");
            return;
          }
        }
      }

      const {
        data: { data },
      } = await fetchData({
        url: SAVE_INSPECTION_PROGRESS_URL,
        data: fieldValues,
        method: "POST",
      });
      ModalConfirm({
        title: "검수저장",
        description: "데이터가 저장되었습니다. ",
      });
      setState("normaled");
      setFieldValues(initItem);
    }
  };

  const handleChangeField = useCallback(async (event) => {
    const { name, value } = event.target;
    //console.log("name === " + name + " || value === " + value);
    if (name === "schPlantCd" && value === "") {
      setPrimaryParameters({
        ...primaryParameters,
        [name]: value,
        ["schScrapAreaCd"]: "",
        ["schSystemCd"]: "",
      });
    } else {
      var systemCd =
        event.target.options[event.target.selectedIndex].getAttribute(
          "data-value"
        );
      setPrimaryParameters({
        ...primaryParameters,
        [name]: value,
        ["schSystemCd"]: systemCd,
      });
      await codeSearch(value);
    }
  });

  const onCameraClick = async (schScrapAreaCd, schSystemCd, tmsOdrNo) => {
    await onCamera(schScrapAreaCd, schSystemCd);

    if (tmsOdrNo === "" || tmsOdrNo === undefined || tmsOdrNo === null) {
      setFieldValues(initItem);
    } else {
      await searchWeightInfo(tmsOdrNo, schScrapAreaCd);
    }
  };

  const searchWeightInfo = async (tmsOdrNo, schScrapAreaCd) => {
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_WEIGHTIN_URL,
      params: {
        tmsOdrNo: tmsOdrNo,
      },
    });

    //console.log(data);

    if (data.length > 0) {
      var weightInfo = data[0];

      let item = {
        status: "C",
        systemCd: weightInfo.systemCd,
        inspNo: weightInfo.wssId,
        inspDt: "",
        plantCd1: weightInfo.plantCd1,
        plantCd: weightInfo.plantCd,
        transCd: weightInfo.transCd,
        vhclNo: weightInfo.vhclNo,
        vhclType: weightInfo.vhclType,
        totalWeight: weightInfo.totalWeight,
        itemCd: weightInfo.itemCd,
        vndrCd: weightInfo.vndrCd,
        vndrNm: weightInfo.vndrNm,
        rvndrCd: weightInfo.rvndrCd,
        rvndrNm: weightInfo.rvndrNm,
        loadAreaCd: weightInfo.loadAreaCd,
        loadAreaNm: weightInfo.loadAreaNm,
        scrapAreaCd: schScrapAreaCd,
        scrapAreaNm: "",
        magnet: "",
        dcsnItemCd: "",
        subItemCd1: "",
        subItemPrdCd1: "",
        subItemRate1: "",
        subItemCd2: "",
        subItemPrdCd2: "",
        subItemRate2: "",
        subItemCd3: "",
        subItemPrdCd3: "",
        subItemRate3: "",
        outageCd: "",
        outageWght: "",
        outageRsn: "",
        returnCd: "",
        returnWght: "",
        returnRsn: "",
        dprctCd: "",
        dprctRate: "",
        scalNo: "",
        tmsOdrNo: weightInfo.tmsOdrNo,
        workerId: "",
        inspCd: "R",
        rmks: "",
        wghtDt: weightInfo.inptDt,
        returnCnt: weightInfo.returnCnt,
      };
      setFieldValues(item);
      setPrimaryParameters({
        ...primaryParameters,
        ["systemCd"]: weightInfo.systemCd,
        ["schPlantCd"]: weightInfo.plantCd1,
        ["schScrapAreaCd"]: weightInfo.scrapAreaCd,
      });
      setState("created");
    } else {
      setFieldValues(initItem);
      setState("normaled");
    }
  };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  //마일스톤정보를 검색
  const searchMilestone = async (systemCd) => {
    const mInfo = await fetchData({
      url: SEARCH_MILESTONE_URL,
      params: {
        systemCd: systemCd,
      },
    });

    //setMilestoneInfo(mInfo.data.data[0]);
    return mInfo.data.data[0];
  };

  //하차지역의 카메라 리스트 검색
  const searchCameraList = async (schScrapAreaCd) => {
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_CAMERA_URL,
      params: {
        scrapAreaCd: schScrapAreaCd,
      },
    });
    return data;
  };

  //하차지역의 녹화만 가능한 카메라 검색
  const searchRecordCameraList = async (schScrapAreaCd) => {
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_RECORDCAMERA_URL,
      params: {
        scrapAreaCd: schScrapAreaCd,
      },
    });
    return data;
  };

  //단일 카메라 정보 검색
  const searchCameraInfo = async (cameraGuid) => {
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_CAMERAINFO_URL,
      params: {
        cameraGuid: cameraGuid,
      },
    });
    return data[0];
  };

  //화면에 카메라의 영상을 보여주는 기능
  const onCamera = async (schScrapAreaCd, schSystemCd) => {
    //console.log(schSystemCd);
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_CAMERA_URL,
      params: {
        scrapAreaCd: schScrapAreaCd,
      },
    });

    const cameraInfo = await searchCameraList(schScrapAreaCd);

    let actionViewers = [];
    viewerRef0.current.onCameraDestory();
    viewerRef1.current.onCameraDestory();
    viewerRef2.current.onCameraDestory();
    viewerRef3.current.onCameraDestory();

    //console.log(schSystemCd);
    const milestone = await searchMilestone(schSystemCd);

    //console.log(milestone);
    if (cameraInfo.length > 0) {
      await sleep(500);
      if (cameraInfo[0] !== undefined) {
        viewerRef0.current.onCameraStart(cameraInfo[0]);
        viewerRef0.current.initMilestone(cameraInfo[0].cameraGuid, milestone);
      } else {
        viewerRef0.current.onCameraDestory();
      }
      await sleep(500);
      if (cameraInfo[1] !== undefined) {
        viewerRef1.current.onCameraStart(cameraInfo[1]);
        viewerRef1.current.initMilestone(cameraInfo[1].cameraGuid, milestone);
      } else {
        viewerRef1.current.onCameraDestory();
      }
      await sleep(500);
      if (cameraInfo[2] !== undefined) {
        viewerRef2.current.onCameraStart(cameraInfo[2]);
        viewerRef2.current.initMilestone(cameraInfo[2].cameraGuid, milestone);
      } else {
        viewerRef2.current.onCameraDestory();
      }
      await sleep(500);
      if (cameraInfo[3] !== undefined) {
        viewerRef3.current.onCameraStart(cameraInfo[3]);
        viewerRef3.current.initMilestone(cameraInfo[3].cameraGuid, milestone);
      } else {
        viewerRef3.current.onCameraDestory();
      }
    }
  };

  //카메라 수동녹화 시작
  const onCameraStart = async () => {
    if (
      await ModalConfirm({
        title: "수동녹화",
        description: "수동녹화를 하시겠습니까?",
      })
    ) {
      onCameraRecord("recon");
    }
  };

  //입차계근 팝업으로 호출할 경우 자동녹화를 시작
  const onSetRecord = async (inspNo, tmsOdrNo) => {
    const status = "recon";
    recordingValue.map(async (record) => {
      //console.log(record);
      if (record.scrapAreaCd === primaryParameters.schScrapAreaCd) {
        if (status === "recon") {
          ModalConfirm({
            title: "수동녹화",
            description: "현재 녹화중입니다. ",
          });
          return;
        }
      }
    });

    const cameraInfo = await searchRecordCameraList(
      primaryParameters.schScrapAreaCd
    );

    //console.log(cameraInfo);
    cameraInfo.map(async (camera) => {
      const response = await axios({
        method: "POST",
        url:
          primaryParameters.schScrapAreaCd.indexOf("1200N") >= 0
            ? CAMERA_RECORD_URL_NRC
            : primaryParameters.schScrapAreaCd.indexOf("2100") >= 0
            ? CAMERA_RECORD_URL_GP
            : CAMERA_RECORD_URL_NS,
        data: {
          ...camera,
          inspNo: inspNo,
          tmsOdrNo: tmsOdrNo,
          status: status,
        },
      }).catch(function (error) {
        if (error.response) {
          // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
          //console.log(error.response.data);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          toast.error("이미 영상녹화를 하셨습니다. ");
        } else if (error.request) {
          // 요청이 이루어 졌으나 응답을 받지 못했습니다.
          // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
          // Node.js의 http.ClientRequest 인스턴스입니다.
          //console.log(error.request);
        } else {
          // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
          //console.log("Error", error.message);
        }
        //console.log(error.config);
      });

      /*
      const response1 = fetchData({
        url: CAMERA_RECORD_URL,
        data: {
          ...camera,
          inspNo: fieldValues.inspNo,
          tmsOdrNo: fieldValues.tmsOdrNo,
          status: status,
        },
        method: "POST",
      });
      */
    });
  };

  //카메라 수동녹화 종료
  const onCameraStop = async () => {
    if (
      await ModalConfirm({
        title: "수동녹화",
        description: "수동녹화를 중지하시겠습니까?",
      })
    ) {
      onCameraRecord("recoff");
    }
  };

  const onCameraRecord = async (status) => {
    if (fieldValues.inspNo === "" && status === "recon") {
      ModalConfirm({
        title: "수동녹화",
        description: "계근정보가 없습니다. ",
      });
      return;
    }

    var recData = null;
    recordingValue.map(async (record) => {
      //console.log(record);
      if (record.scrapAreaCd === primaryParameters.schScrapAreaCd) {
        if (status === "recon") {
          ModalConfirm({
            title: "수동녹화",
            description: "현재 녹화중입니다. ",
          });
          return;
        }

        recData = record;
      }
    });

    //console.log(recData);

    const cameraInfo = await searchRecordCameraList(
      primaryParameters.schScrapAreaCd
    );

    //console.log(cameraInfo);
    cameraInfo.map(async (camera) => {
      const response = await axios({
        method: "POST",
        url:
          primaryParameters.schScrapAreaCd.indexOf("1200N") >= 0
            ? CAMERA_RECORD_URL_NRC
            : primaryParameters.schScrapAreaCd.indexOf("2100") >= 0
            ? CAMERA_RECORD_URL_GP
            : CAMERA_RECORD_URL_NS,
        data: {
          ...camera,
          inspNo: recData.inspNo,
          tmsOdrNo: recData.tmsOdrNo,
          status: status,
        },
      }).catch(function (error) {
        if (error.response) {
          // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
          //console.log(error.response.data);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          toast.error("이미 영상녹화를 하셨습니다. ");
        } else if (error.request) {
          // 요청이 이루어 졌으나 응답을 받지 못했습니다.
          // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
          // Node.js의 http.ClientRequest 인스턴스입니다.
          //console.log(error.request);
        } else {
          // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
          //console.log("Error", error.message);
        }
        //console.log(error.config);
      });
    });
  };

  const onSnapShot = async (cameraGuid) => {
    if (fieldValues.inspNo === "") {
      ModalConfirm({
        title: "스냅샷",
        description: "계근정보가 없습니다. ",
      });
      return;
    }
    const cameraInfo = await searchCameraInfo(cameraGuid);
    const milestone = await searchMilestone(fieldValues.systemCd);

    const response = await axios({
      method: "GET",
      url:
        primaryParameters.schScrapAreaCd.indexOf("1200N") >= 0
          ? CAMERA_SNAPSHOT_URL_NRC
          : primaryParameters.schScrapAreaCd.indexOf("2100") >= 0
          ? CAMERA_SNAPSHOT_URL_GP
          : CAMERA_SNAPSHOT_URL_NS,
      params: {
        ...milestone,
        inspNo: fieldValues.inspNo,
        maxWidth: "1280",
        maxHeight: "1024",
        cameraGuid: cameraGuid,
        cameraNm: cameraInfo.cameraNm,
        //status: status,
      },
    }).catch(function (error) {
      if (error.response) {
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        //console.log(error.response.status);
        //console.log(error.response.headers);
        toast.error("스냅샷 오류 : " + error.response.data.error.message);
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        //console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        //console.log("Error", error.message);
      }
      //console.log(error.config);
    });

    /*
    const response1 = fetchData({
      url: CAMERA_SNAPSHOT_URL,
      params: {
        ...milestone,
        inspNo: fieldValues.inspNo,
        maxWidth: "1280",
        maxHeight: "1024",
        cameraGuid: cameraGuid,
        cameraNm: cameraInfo.cameraNm,
        //status: status,
      },
    });
    */
  };
  const onViewFull = () => {};

  //_target : 적용시킬 element
  //_class : 적용시킬 class
  function toggleClass(_target, _class) {
    var menu = document.getElementById(_target);
    if (hasClass(menu, _class)) {
      removeClass(menu, _class);
    } else {
      addClass(menu, _class);
    }
  }

  function addClass(element, className) {
    element.className += " " + className;
  }
  function removeClass(element, className) {
    var check = new RegExp("(\\s|^)" + className + "(\\s|$)");
    element.className = element.className.replace(check, " ").trim();
  }

  function hasClass(element, className) {
    if (element.className.indexOf(className) > -1) {
      return true;
    } else {
      return false;
    }
  }

  const onStop = async () => {
    viewerRef0.current.onCameraStop();
    viewerRef1.current.onCameraStop();
    viewerRef2.current.onCameraStop();
    viewerRef3.current.onCameraStop();
  };

  const onReconnectCamera = async () => {
    if (primaryParameters.schScrapAreaCd === "") {
      ModalConfirm({
        title: "카메라 다시 연결",
        description: "현재 선택한 하차지가 없습니다. ",
      });
      return;
    }
    var isConnect = true;

    if (
      await ModalConfirm({
        title: "카메라 다시 연결",
        description: "카메라를 다시 연결하시겠습니까?",
      })
    ) {
      let response = await axios({
        method: "GET",
        url:
          primaryParameters.schScrapAreaCd.indexOf("1200") >= 0
            ? CAMERA_RECONNECT_URL_DH
            : CAMERA_RECONNECT_URL_YK,
        params: {
          scrapAreaCd: primaryParameters.schScrapAreaCd,
        },
      }).catch(function (error) {
        isConnect = false;
      });

      sleep(500);

      if (!isConnect) {
        response = await axios({
          method: "GET",
          url: CAMERA_RECONNECT_URL,
          params: {
            scrapAreaCd: primaryParameters.schScrapAreaCd,
          },
        });
      }
      sleep(500);

      onCamera(primaryParameters.schScrapAreaCd, primaryParameters.schSystemCd);
    }
  };
  return (
    <>
      <SearchBar
        primaryParameters={primaryParameters}
        handleChangeField={handleChangeField}
        recordingValue={recordingValue}
        onCameraStart={onCameraStart}
        onCameraStop={onCameraStop}
        onStop={onStop}
        onReconnectCamera={onReconnectCamera}
      />
      <div className="scrollbox clear">
        <ul className="select_tab" id="mMenuTabs">
          {codeData &&
            codeData.map((code, index) => (
              <li
                onClick={async () => {
                  await setPrimaryParameters({
                    ...primaryParameters,
                    ["systemCd"]: code.attr5,
                    ["schPlantCd"]: code.attr3,
                    ["schScrapAreaCd"]: code.detlCd,
                  });
                  await codeSearch(code.attr3);
                  await onCameraClick(
                    code.detlCd,
                    code.attr5,
                    recordingValue.find(
                      (value) => value.scrapAreaCd === code.detlCd
                    )
                      ? recordingValue.find(
                          (value) => value.scrapAreaCd === code.detlCd
                        ).tmsOdrNo
                      : ""
                  );
                }}
                id={"lab" + index}
                className={
                  code.detlCd === primaryParameters.schScrapAreaCd ? "on" : ""
                }
              >
                <div>
                  {recordingValue.find(
                    (value) => value.scrapAreaCd === code.detlCd
                  ) ? (
                    <img src={cameraIcon} className="videoIMG play" />
                  ) : (
                    ""
                  )}

                  <p>
                    <b>
                      {recordingValue.find(
                        (value) => value.scrapAreaCd === code.detlCd
                      )
                        ? recordingValue
                            .find((value) => value.scrapAreaCd === code.detlCd)
                            .vhclNo.slice(-4)
                        : fieldValues.scrapAreaCd === code.detlCd
                        ? fieldValues.vhclNo.slice(-4)
                        : ""}
                    </b>
                  </p>
                </div>
                <div>
                  <p>
                    {code.attr4}
                    <br />
                    {code.cdNmKor}
                  </p>
                </div>
              </li>
            ))}
        </ul>
      </div>
      <div className="flexible_contents_box3">
        <div className="databox cctv_half">
          <div className="tabbox" id="mTabContents">
            <div className="cctv_list on">
              <ul className="view_list">
                <li
                  id="Viewer1"
                  onClick={(event) => toggleClass("Viewer1", "expand1")}
                >
                  <Viewer ref={viewerRef0} onSnapShot={onSnapShot} />
                </li>
                <li
                  id="Viewer2"
                  onClick={(event) => toggleClass("Viewer2", "expand2")}
                >
                  <Viewer ref={viewerRef1} onSnapShot={onSnapShot} />
                </li>
                <li
                  id="Viewer3"
                  onClick={(event) => toggleClass("Viewer3", "expand3")}
                >
                  <Viewer ref={viewerRef2} onSnapShot={onSnapShot} />
                </li>
                <li
                  id="Viewer4"
                  onClick={(event) => toggleClass("Viewer4", "expand4")}
                >
                  <Viewer ref={viewerRef3} onSnapShot={onSnapShot} />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="databox">
          <div className="subdatabox">
            <div id="mTableTab">
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => {
                  setKey(k);
                }}
                className="mb-3"
              >
                <Tab
                  eventKey="inspection"
                  title="검수입력"
                  style={{ fontSize: "14px" }}
                >
                  <InspectionReg
                    state={state}
                    fieldValues={fieldValues}
                    setFieldValues={setFieldValues}
                    primaryParameters={primaryParameters}
                    setPrimaryParameters={setPrimaryParameters}
                    handleMasterSave={handleMasterSave}
                    handleIncomingClick={handleIncomingClick}
                  />
                </Tab>

                <Tab eventKey="outgoing" title="출차대기">
                  <OutgoingWaitList
                    fieldValues={fieldValues}
                    primaryParameters={primaryParameters}
                  />기
                </Tab>

                <Tab eventKey="incomehistory" title="입고이력">
                  <IncomeHistory fieldValues={fieldValues} />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default InspectionProgressReg;
